import {
  BLOCKING_THERMAL_STATES,
  MIN_BATTERY_LEVEL,
  MIN_DELIVERED_FPS,
} from './constants';
import type {
  DeviceHealthEvaluation,
  DeviceHealthSnapshot,
  RppgAbortReasonCode,
} from './types';

/**
 * Pure evaluator for rPPG device/runtime health.
 * Order matches product priority for user-facing messages (same as native).
 */
export function evaluateDeviceHealth(
  snapshot: DeviceHealthSnapshot,
  options?: {
    includeFps?: boolean;
    includeCameraInterrupt?: boolean;
  },
): DeviceHealthEvaluation {
  const includeFps = options?.includeFps ?? false;
  const includeCameraInterrupt = options?.includeCameraInterrupt ?? true;
  const reasons: RppgAbortReasonCode[] = [];

  if (includeCameraInterrupt && snapshot.cameraInterrupted) {
    reasons.push('CAMERA_INTERRUPTED');
  }

  if (snapshot.lowPowerMode) {
    reasons.push('LOW_POWER_MODE');
  }

  if (BLOCKING_THERMAL_STATES.has(snapshot.thermalState)) {
    reasons.push('THERMAL_THROTTLING');
  }

  if (
    snapshot.batteryLevel != null &&
    Number.isFinite(snapshot.batteryLevel) &&
    snapshot.batteryLevel < MIN_BATTERY_LEVEL
  ) {
    reasons.push('LOW_BATTERY');
  }

  if (
    includeFps &&
    snapshot.deliveredFps != null &&
    Number.isFinite(snapshot.deliveredFps) &&
    snapshot.deliveredFps < MIN_DELIVERED_FPS
  ) {
    reasons.push('LOW_FRAME_RATE');
  }

  return {
    healthy: reasons.length === 0,
    reasons,
  };
}
